module.exports = __webpack_public_path__ + "img/ЗВ-13(КВ)-007.59b7d248.png";